// JIV-19357: For the current use case, we just want to escape angle brackets to avoid HTML comment breakages.
// This should match the inverse of jira/src/entry-fs/utils/early-graphql-fetch-utils/escape-html.tsx
const REGEX_HTML_UNESCAPE = /&lt;|&gt;/g;

const UNESCAPE_HTML_MAP: Record<string, string> = {
	'&lt;': '<',
	'&gt;': '>',
};

const unescapeHTML = (str: string): string =>
	str.replace(REGEX_HTML_UNESCAPE, (token: string) => UNESCAPE_HTML_MAP[token]);

export default unescapeHTML;
